<template>
  <v-row class="home">
    <!-- alert -->
    <v-col cols="12" class="pa-0 d-none" v-if="Object.keys(alertCertificate).length && alertCertificate.show_notification">
      <v-alert class="mb-3 inf-alert-error" text outlined color="error" rounded dense>
        <div class="d-flex pa-0 align-center">
          <v-icon color="error">mdi-alert</v-icon>
          <div class="ml-5 alert-description-dash">
            <span class="body-1 font-weight-bold error--text">Certificado digital</span>
            <span class="d-block body-2 error--text pb-1">
              <template v-if="alertCertificate.status === 'active'">
                Te queda{{alertCertificate.days_left > 1 ? 'n' : ''}} <span class="font-weight-bold">{{alertCertificate.days_left }} {{ alertCertificate.days_left > 1 ? 'días' : 'día'}}</span> restantes, con fecha de vencimiento:
              </template>
              <template v-else>Tu certificado digital venció el</template>
              <span class="font-weight-bold" v-if="alertCertificate?.date_end"> {{ alertCertificate?.date_end | date }}</span>
            </span>
          </div>
          <v-spacer />
          <v-btn v-if="$helpers.hasPermission(['add_genericcertificate'])" :to="{ name: 'IrsBuiltInSettings' }" color="error">Gestionar certificado</v-btn>
        </div>
      </v-alert>
    </v-col>
    <!-- end alert -->
    <v-col cols="12" class="pa-0 mt-3">
      <v-card class="panel-home" width="100%" height="200" :style="`margin-bottom:${setMarginBottom}`">
        <v-img min-width="100%" :min-height="200" :src="require(`@/assets/backgrounds/background-panel-hello${$vuetify.theme.dark ? '--dark' : ''}.svg`)">
          <v-row class="fill-height ma-0" align="center">
            <span class="d-block pl-12 title-panel blue-500--text">¡Hola{{ $store.state.auth.userAccount.given_name ? ` ${$store.state.auth.userAccount.given_name}`: ''}}!
              <span class="d-inline-block text-h1 ml-3" style="margin-top: -20px; position: absolute">👋🏼</span>
            </span>
          </v-row>
        </v-img>
      </v-card>
      <v-col class="px-0 text-end">
        <v-row align="center" :class="[$vuetify.breakpoint.width > 2500  ? 'mt-n3' : 'mt-n10', 'mb-n2']" no-gutters>
          <span class="font-weight-bold subtitle-2 grey-700--text">Tus accesos directos</span>
          <v-spacer />
          <v-btn @click="dialog=true" text color="blue-500" :ripple="false">
            <span class="font-weight-medium body-1 blue-500--text">Editar accesos directos</span>
            <v-icon small class="ml-2">mdi-open-in-new</v-icon>
          </v-btn>
        </v-row>
        <v-row v-for="(shortcut, i) in currentShortcutsList" :key="i">
          <v-col cols="3" class="" v-for="children in shortcut.children" :key="children.title">
            <!-- <v-hover v-slot="{ hover }"> -->
              <v-card class="px-5 py-7" :to="{ name: children.route, params: $route.params }" height="80" min-width="190"> <!--:elevation="hover ? 6 : 0"-->
                <v-row class="fill-height ma-0 text-left" align="center">
                  <v-img contain :height="44" style="position: absolute" :src="require(`@/assets/shortcuts-icons/avatars/${children.icon}--avatar.svg`)" />
                  <span class="d-inline-block grey-700--text font-weight-bold ml-14 pl-2" :class="$vuetify.breakpoint.width <= 1200 ? 'body-2' : 'subtitle-2'" style="line-height: normal" >{{ children.title === 'SII' ? $t('generals.SII') : children.title }}</span>
                </v-row>
              </v-card>
            <!-- </v-hover> -->
          </v-col>
        </v-row>
      </v-col>
    </v-col>
    <!-- dialog -->
    <v-dialog v-model="dialog" width="1185" persistent scrollable no-click-animation overlay-color="grey-500">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="46" class="transparent">
            <v-toolbar-title class="px-5 subtitle-2 grey-500--text font-weight-semibold">Accesos directos</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="clear" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 pb-6">
          <!-- alert -->
          <v-alert class="inf-alert blue-500--text" :height="45" dense text outlined tile>
            <div class="d-flex align-center pa-0">
              <v-icon color="blue-500" size="22">mdi-information</v-icon>
              <div class="ml-4 py-0">
                <span class="body-1">Selecciona hasta
                  <span class="font-weight-bold">8 accesos directos</span>
                </span>
              </div>
            </div>
          </v-alert>
          <!-- end alert -->
          <v-col class="px-5 pb-1" v-for="(section) in shortcutsForModal" :key="section.title">
            <span class="font-weight-bold subtitle-2 grey-700--text">{{ section.title }}</span>
            <v-row class="mt-4" no-gutters>
              <v-col cols="2" :class="{'pr-3' : i !== getValidChildren(section).length - 1 }" v-for="(children, i) in getValidChildren(section)" :key="children.title" style="max-width: 20.6% !important;">
                <v-card class="pa-3" outlined style="border-radius: 5px" @click.stop="children.show = !children.show, getShortcuts(children)" :ripple="false">
                  <v-row class="ma-0 mt-n1" align="center" no-gutters>
                    <v-sheet height="38">
                      <v-row class="ma-0" align="center">
                        <v-img contain :height="44" style="position: absolute" :src="require(`@/assets/shortcuts-icons/${ section.title === 'Configuración' ? children.icon : section.icon}--icon.svg`)" />
                        <v-sheet class="ml-7 body-2 align-center d-flex grey-700--text" width="90" height="40" style="line-height: normal">{{ children.title === 'SII' ? $t('generals.SII') : children.title }}</v-sheet>
                        <v-checkbox class="mt-n1" color="blue-500" v-model="children.show" @click.stop="getShortcuts(children)" :ripple="false" dense hide-details style="position: absolute; right: 8px"/>
                      </v-row>
                    </v-sheet>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-2 px-5">
          <v-spacer/>
          <v-btn outlined @click="clear" :ripple="false">Cancelar</v-btn>
          <v-btn color="blue-500" @click="saveShortCuts" :ripple="false">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog -->
  </v-row>
</template>
<script>
import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    loadingAlertCertificate: false,
    alertCertificate: {},
    dialog: false,
    list: [],
    listCL: ['Documentos emitidos', 'Crear documentos', 'SII', 'Documentos recibidos', 'Cuadratura', 'Emisión por lotes', 'Clientes', 'Tiendas'],
    listPE: ['Documentos emitidos', 'Tiendas', 'SII', 'Documentos recibidos', 'Cuadratura', 'Emisión por lotes', 'Clientes', 'Organización'],
    currentShortcutsList: [],
    shortcuts: [
      {
        icon: 'metrics',
        title: 'Métricas',
        description: '',
        countries: ['CL', 'PE'],
        show: false,
        children: [
        {
            icon: 'metrics',
            title: 'Resumen emisión',
            description: '',
            route: 'MetricsList',
            countries: ['CL', 'PE'],
            show: false,
            children: []
          },
          {
            icon: 'metrics',
            title: 'Resumen recepción',
            description: '',
            route: 'RecMetricsList',
            countries: ['CL', 'PE'],
            show: false,
            children: []
          },
          {
            icon: 'metrics',
            title: 'Ventas por tienda',
            description: '',
            route: 'StoreSales',
            countries: ['CL', 'PE'],
            show: false,
            permission: 'view_metrics_branches',
            children: []
          },
          {
            icon: 'metrics',
            title: "Ventas de la organización",
            description: '',
            route: "OrganizationSales",
            countries: ['CL', 'PE'],
            show: false,
            permission: 'view_metrics_account',
            children: []
          }
        ]
      },
      {
        icon: 'documents',
        title: 'Emisión',
        description: '',
        countries: ['CL', 'PE'],
        show: false,
        children: [
          {
            icon: 'documents',
            title: 'Documentos emitidos',
            route: 'DocumentsList',
            countries: ['CL', 'PE'],
            show: false
          },
          {
            icon: 'documents',
            title: 'Resúmenes',
            route: 'SummariesList',
            countries: ['PE'],
            show: false
          },
          {
            icon: 'documents',
            title: 'Crear documentos',
            route: 'DocumentsCreate',
            countries: ['CL'],
            show: false
          },
          {
            icon: 'documents',
            title: 'Emisión por lotes',
            route: 'DocumentsBatchListCreate',
            countries: ['CL', 'PE'],
            show: false
          },
          {
            icon: 'documents',
            title: 'Cuadratura',
            route: 'ReconciliationsListCreate',
            countries: ['CL', 'PE'],
            show: false
          },
          {
            icon: 'documents',
            title: 'Clientes',
            route: 'CustomerListCreate',
            countries: ['CL', 'PE'],
            show: false
          },
          {
            icon: 'documents',
            title: 'SIRE',
            route: 'SireList',
            countries: ['PE'],
            show: false
          }
        ]
      },
      {
        icon: 'purchases',
        title: 'Recepción',
        description: '',
        countries: ['CL', 'PE'],
        show: false,
        children: [
          {
            icon: 'purchases',
            title: 'Documentos recibidos',
            route: 'PurchaseList',
            countries: ['CL', 'PE'],
            show: false
          },
          {
            icon: 'purchases',
            title: 'Pendientes por recibir',
            route: 'PendingReceiveList',
            countries: ['CL'],
            show: false,
            accountOption: 'pending_documents'
          },
          {
            icon: 'purchases',
            title: 'Proveedores',
            route: 'SupplierListCreate',
            countries: ['CL', 'PE'],
            show: false,
            accountOption: 'rec_process_rules'
          },
          {
            icon: 'purchases',
            title: 'Categorías',
            route: 'SuppliersCategoriesList',
            countries: ['CL', 'PE'],
            show: false,
            accountOption: 'rec_process_rules'
          }
        ]
      },
      {
        icon: 'pos',
        title: 'POS',
        description: '',
        countries: ['CL', 'PE'],
        show: false,
        children: [
          {
            icon: 'pos',
            title: 'Tiendas',
            route: 'BranchListCreate',
            countries: ['CL', 'PE'],
            show: false
          }
        ]
      },
      {
        icon: 'account',
        title: 'Configuración',
        description: '',
        countries: ['CL', 'PE'],
        show: false,
        children: [
          {
            icon: 'account',
            title: 'Organización',
            route: 'AccountBasic',
            countries: ['CL', 'PE'],
            show: false
          },
          {
            icon: 'sii',
            title: 'SII',
            route: 'IrsBuiltInSettings',
            countries: ['CL', 'PE'],
            show: false
          },
          {
            icon: 'developers',
            title: 'Developers',
            route: 'AccountSettingsWebhooksListCreate',
            countries: ['CL', 'PE'],
            show: false
          },
           {
            icon: 'pos',
            title: 'Configuración de POS',
            route: 'AccountSendLogPos',
            countries: ['CL', 'PE'],
            show: false
          }
        ]
      }
    ],
    min: 0,
    max: 0,
    backupList: []
  }),
  computed: {
    setMarginBottom () {
      if (this.$vuetify.breakpoint.width < 1400) return '4%'
      else if (this.$vuetify.breakpoint.width < 1500) return '5%'
      else if (this.$vuetify.breakpoint.width < 1700) return '6.5%'
      else if (this.$vuetify.breakpoint.width < 1900) return '7%'
      return '9.5%'
    },
    filteredShortcuts () {
      const currentCountry = this.$store.state.auth.account?.country
      if (!currentCountry) return []
      return this.shortcuts
        .filter(item => {
          // Filter by country
          if (!item.countries || !item.countries.includes(currentCountry)) return false

          // Filter by permissions if defined
          if (item.permission && !this.$helpers.hasPermission([item.permission])) return false

          // Filter by account option if defined
          if (item.accountOption && !this.hasAccountOption(item.accountOption)) return false

          return true
        })
        .map(item => ({
          ...item,
          children: (item.children || []).filter(child => {
            // Filter children by country
            if (!child.countries || !child.countries.includes(currentCountry)) return false

            // Filter children by permissions if defined
            if (child.permission && !this.$helpers.hasPermission([child.permission])) return false

            // Filter children by account option if defined
            if (child.accountOption && !this.hasAccountOption(child.accountOption)) return false

            return true
          })
        }))
    },
    shortcutsForModal () {
      const currentCountry = this.$store.state.auth.account?.country
      if (!currentCountry) return []
      return this.shortcuts
        .filter(item => {
          // Filter by country
          if (!item.countries || !item.countries.includes(currentCountry)) return false

          // Filter by permissions if defined
          if (item.permission && !this.$helpers.hasPermission([item.permission])) return false

          // Filter by account option if defined
          if (item.accountOption && !this.hasAccountOption(item.accountOption)) return false

          // Check if has valid children
          const validChildren = (item.children || []).filter(child => {
            if (!child.countries || !child.countries.includes(currentCountry)) return false

            if (child.permission && !this.$helpers.hasPermission([child.permission])) return false
            if (child.accountOption && !this.hasAccountOption(child.accountOption)) return false
            return true
          })

          return validChildren.length > 0
        })
    }
  },
  created () {
    const country = this.$store.state.auth.account?.country
    this.list = country === 'CL' ? [...this.listCL] : [...this.listPE]
  },
  mounted () {
    this.setShortCuts()
  },
  watch: {
    '$store.state.auth.account.acc_id' (val) {
      this.list = val === 'CL' ? this.listCL : this.listPE
    }
  },
  methods: {
    hasAccountOption (option) {
      const accountOptions = this.$store.state.auth.account?.options || []
      return accountOptions.includes(option)
    },
    getValidChildren (section) {
      const currentCountry = this.$store.state.auth.account?.country
      if (!currentCountry || !section.children) return []

      return section.children.filter(child => {
        if (!child.countries || !child.countries.includes(currentCountry)) return false
        if (child.permission && !this.$helpers.hasPermission([child.permission])) return false
        if (child.accountOption && !this.hasAccountOption(child.accountOption)) return false
        return true
      })
    },
    filterByCountry (shortcuts, country) {
      if (!country || !shortcuts) return []
      return shortcuts
        .filter(item => {
          // Filter by country
          if (!item.countries || !item.countries.includes(country)) return false

          // Filter by permissions if defined
          if (item.permission && !this.$helpers.hasPermission([item.permission])) return false

          // Filter by account option if defined
          if (item.accountOption && !this.hasAccountOption(item.accountOption)) return false

          return true
        })
        .map(item => ({
          ...item,
          children: item.children ? this.filterByCountry(item.children, country) : []
        }))
    },
    /* eslint-disable */
    getShortcuts (children) {
      if (this.list.length <= 4) {
        if (this.list.includes(children.title)) {
          this.min += 1
          if (this.min === 1) {
            this.$dialog.message.error('Debes tener al menos 4 accesos directos para acceder rápidamente a tus funciones favoritas.')
            setTimeout(() => {
              this.min = 0
            }, 3000)
          }
          this.$nextTick(() => {
            children.show = true
          })
        } else {
          this.list.push(children.title)
          this.$nextTick(() => {
            children.show = true
          })
        }
      } else if (this.list.length >= 8) {
        if (this.list.includes(children.title)) {
          this.list.splice(this.list?.indexOf(children.title), 1)
        } else {
          this.max += 1
          if (this.max === 1) {
            this.$dialog.message.error('Debes tener hasta 8 accesos directos para acceder rápidamente a tus funciones favoritas.')
            setTimeout(() => {
              this.max = 0
            }, 3000)
          }
          this.$nextTick(() => {
            children.show = false
          })
        }
      } else {
        if (!this.list.includes(children.title)) {
          this.list.push(children.title)
        } else {
          this.list.splice(this.list?.indexOf(children.title), 1)
        }
      }
    },
    saveShortCuts () {
      let recovery = JSON.parse(localStorage.getItem('shortcuts-ax')) ?? []
      const index = recovery?.findIndex(({account_id}) => account_id === this.$store.state.auth.account.acc_id)
      if (index !== -1) {
        recovery[index].shortcuts = this.list
      } else {
        recovery.push({ account_id: this.$store.state.auth.account.acc_id, shortcuts: this.list })
      }

      localStorage.setItem('shortcuts-ax', JSON.stringify(recovery))
      this.setShortCuts()
      this.dialog = false
    },
    setShortCuts () {
      const currentCountry = this.$store.state.auth.account?.country
      if (!currentCountry) return
      
      const recovery = JSON.parse(localStorage.getItem('shortcuts-ax'))
      const found = recovery?.find(({account_id}) => account_id === this.$store.state.auth.account.acc_id)
      this.list = found?.shortcuts ?? this.list
      let array = []

      this.shortcuts?.forEach((item) => {
        // Check if item should be displayed based on country, permissions and account options
        if (!item.countries || !item.countries.includes(currentCountry)) return
        if (item.permission && !this.$helpers.hasPermission([item.permission])) return
        if (item.accountOption && !this.hasAccountOption(item.accountOption)) return

        const children = item.children || []
        children.forEach((child) => {
          // Check if children should be displayed based on country, permissions and account options
          if (!child.countries || !child.countries.includes(currentCountry)) return
          if (child.permission && !this.$helpers.hasPermission([child.permission])) return
          if (child.accountOption && !this.hasAccountOption(child.accountOption)) return

          if (this.list.includes(child.title)) {
            child.show = true
            array.push(child)
            this.currentShortcutsList = [{ ...item, children: array}]
          }
        })
      })
      this.backupList = [...this.list]
    },
    clear () {
      this.list = [...this.backupList]
      this.shortcuts.forEach((item) => {
        const children = item.children || []
        children.forEach((child) => {
          child.show = this.list.includes(child.title)
        })
      })
      this.dialog = false
    }
  }
}
</script>